import SuccessStoriesListPageContainer from './containers/SuccessStoriesListPageContainer'

export default SuccessStoriesListPageContainer
